import { BenutzerDetailApiDto, BenutzerInfoSearchResultApiDto, TakeTeilnehmerApiDto, TeilnehmerListApiDto } from '@/api-schema';
import { BenutzerInfoSearchApiDto } from '@/types/BenutzerInfoSearchApiDto';
import { TeilnehmerFilterDto } from '@/types/TeilnehmerFilterDto';
import { TeilnehmerBenutzerDto } from '@/types/UserDtos';

export interface ITreuhandEinstellungenState {
    benutzerFilter: BenutzerInfoSearchApiDto;
    benutzerInfoSearchResultApiDto: BenutzerInfoSearchResultApiDto;
    benutzerTotalNumberOfRecords: number | null;
    benutzerLoading: boolean;
    benutzerDetails: BenutzerDetailApiDto;
    treuhandBenutzerData: Array<TeilnehmerBenutzerDto>;
}

export const state: ITreuhandEinstellungenState = {
    benutzerFilter: new BenutzerInfoSearchApiDto(),
    benutzerInfoSearchResultApiDto: null,
    benutzerTotalNumberOfRecords: null,
    benutzerLoading: false,
    benutzerDetails: {},
    treuhandBenutzerData: []
};
